import React, { useState, ChangeEvent } from 'react';
import styles from './upload.module.scss';

import Camera from 'assets/icons/camera.svg';
import { useUserContext } from 'context/UserContext';
import { RcFile } from 'antd/lib/upload';

interface CustomImageUploadProps {
  image: RcFile | undefined;
  setImage: React.Dispatch<React.SetStateAction<RcFile | undefined>>;
}

const CustomImageUpload: React.FC<CustomImageUploadProps> = ({
  image,
  setImage,
}) => {
  const { companyImageUrl } = useUserContext();
  const [preview, setPreview] = useState<string>(
    image ? URL.createObjectURL(image) : ''
  );

  const handleImageChange = (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file && (file.type === 'image/png' || file.type === 'image/jpeg')) {
      if (file.size / 1024 / 1024 < 2) {
        setImage(file as RcFile);
        setPreview(URL.createObjectURL(file));
      } else {
        alert('Image must be smaller than 2MB');
      }
    } else {
      alert('Only PNG and JPEG images are allowed');
    }
  };

  return (
    <div className={styles.uploadContainer}>
      <label className={styles.uploadLabel}>
        <input
          type="file"
          onChange={handleImageChange}
          accept="image/png, image/jpeg"
          style={{ display: 'none' }}
        />
        <div className={styles.previewContainer}>
          {companyImageUrl || preview ? (
            <img
              src={preview || companyImageUrl || ''}
              alt="Preview"
              className={styles.imagePreview}
            />
          ) : (
            <div className={styles.imagePreview}></div>
          )}
          <div className={styles.uploadIcon}>
            <img src={Camera} alt="Upload Icon" />
          </div>
        </div>
      </label>
    </div>
  );
};

export default CustomImageUpload;
